<template>
	<div class="page-header">
		<div class="form-row header-style">

			<div class="form-group row col-md-2" style = "margin: 0px;">
				<multiselect
					v-model="selectedVendorDimList"
					:options="vendorsList"
					:show-no-results="true"
					ref="multiselect"
					label="name"
					:track-by="id"
					open-direction="bottom"
					:taggable="false"
					placeholder="dim_profile Vendors"
					class="form-control multi-dropdown"
					selectLabel = ""
					selectedLabel = ""
					@select = "selectVendor($event)"
					/>
			</div>

			<div class="form-group row col-md-2" style = "margin: 0px;">
				<multiselect
					v-model="selectedVendorMasterList"
					:options="vendorMasterList"
					:show-no-results="true"
					ref="multiselect"
					label="vendor_name"
					:track-by="vendor_id"
					open-direction="bottom"
					:taggable="false"
					placeholder="vendor_master Vendors"
					class="form-control multi-dropdown"
					selectLabel = ""
					selectedLabel = ""
					@select = "selectVendor($event)"
					/>
			</div>

			<div class="form-group col-md-7"></div>
			<div class="form-group col-md-1" style = "padding:0px;margin:0px">
				<div v-if="showVendorLoader" class="spinner-border" style=""></div>
				<button
					v-else
					@click="mapItems()"
					class="btn btn-primary add-new-campaign"
				>
					Map Data
				</button>
			</div>


		</div>
	</div>
</template>
<script>
import Multiselect from "vue-multiselect";

	export default {
		name: "MappingFilter",
		components: {
			Multiselect
		},
		props:["vendorMasterList"],
		mounted() {},
		data() {
			return {
				selectedVendorDimList:[],
				selectedVendorMasterList:[],
				showVendorLoader:false
		  };
		},
		computed: {
			vendorsList() {
				let data = this.$store.state.vendorList.filter(e => e.name);
				return data;
			}
		},
		methods: {
			selectVendor(){

			},
			mapItems(){
				

				if(this.selectedVendorDimList && this.selectedVendorMasterList){
					let payload = {
						master_go_vendor_cd:this.selectedVendorMasterList.id,
						dim_go_vendor_cd:this.selectedVendorDimList.id,
						dim_vendor_name:this.selectedVendorDimList.vendor_name,
						master_vendor_name:this.selectedVendorMasterList.vendor_name,
						country:this.selectedVendorDimList.country_code
					}
					
					this.showVendorLoader = true
					let vm = this;
					this.$store.dispatch("map/saveData", payload).then((res) => {
						vm.showVendorLoader = false;
						vm.selectedVendorDimList = [];
						vm.selectedVendorMasterList = [];
					})

				}

			}
		}
	};
</script>
